export default function ForceRefreshPlugin() {
	let forceRefresh = false

	return {
		componentDidUpdate() {
			forceRefresh = false
		},
		shouldNodeComponentUpdate() {
			return forceRefresh ? true : null
		},
		commands: {
			refresh() {
				forceRefresh = true
			},
		},
	}
}
